import { PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPayableStopPeriods } from '@festina/moneyout-general-types/moneyout/hooks/PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPayableStopPeriods'

export const useFetchPayableStopPeriods =
  PaymentReceiversPeriodsService_paymentReceiverPeriodsVersionServiceGetPayableStopPeriods.useSuspenseQuery
